import type { ReactNode } from 'react'
import { cn } from '../../lib/cn'

/** The one segmented control for tabs and filter rows: pill track, pill items, volt-soft active. */
export function SegmentedTabs<T extends string>({ value, onChange, items, className, size = 'default' }: {
  value: T
  onChange: (v: T) => void
  items: Array<{ value: T; label: ReactNode; count?: number }>
  className?: string
  size?: 'default' | 'sm'
}) {
  return (
    <div role="tablist" className={cn('inline-flex max-w-full items-center gap-0.5 overflow-x-auto rounded-full border bg-card p-1', className)}>
      {items.map((it) => {
        const active = it.value === value
        return (
          <button
            key={it.value}
            role="tab"
            type="button"
            aria-selected={active}
            onClick={() => onChange(it.value)}
            className={cn(
              'inline-flex shrink-0 items-center gap-1.5 rounded-full font-medium whitespace-nowrap transition-colors',
              size === 'sm' ? 'h-7 px-2.5 text-xs' : 'h-8 px-3 text-sm',
              active ? 'bg-volt-soft text-volt-ink' : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            {it.label}
            {it.count !== undefined ? <span className={cn('rounded-full px-1.5 text-[10px] tabular-nums', active ? 'bg-volt/15' : 'bg-muted')}>{it.count}</span> : null}
          </button>
        )
      })}
    </div>
  )
}
